<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a href="/admin/dashboard" class="brand-link">
      <img src="@/assets/logo-sdc.png" alt="logo" class="brand-image img-circle elevation-3" style="opacity: .8">
      <span class="brand-text font-weight-light">TRANG CHỦ</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar">

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar" data-widget="treeview" role="menu" data-accordion="false">
          <li v-for="m in menu" :key="m.id" class="nav-item mt-2">
            <router-link :to="m.path" :class="($route.path == m.path) ? 'nav-link active' : 'nav-link'" >
              <span v-html="m.icon"></span>
              <p>{{ m.menuName }}</p>
            </router-link>
          </li>
          <!-- <li class="nav-item mt-2">
            <router-link to="/admin/dashboard" :class="($route.path == '/admin/dashboard') ? 'nav-link active' : 'nav-link'" >
              <i class="fa-solid fa-gauge-high nav-icon"></i>
              <p>Dashboard</p>
            </router-link>
          </li>

          <li class="nav-item mt-2">
            <router-link to="/admin/role" :class="($route.path == '/admin/role') ? 'nav-link active' : 'nav-link'" >
              <i class="fa-solid fa-users-gear nav-icon"></i>
              <p>Quản lý phân quyền</p>
            </router-link>
          </li>

          <li class="nav-item mt-2">
            <router-link to="/admin/user" :class="($route.path == '/admin/user') ? 'nav-link active' : 'nav-link'" >
              <i class="fas fa-user-friends nav-icon"></i>
              <p>Quản lý người dùng</p>
            </router-link>
          </li>

          <li class="nav-item mt-2">
            <router-link to="/admin/workspace" :class="($route.path == '/admin/workspace') ? 'nav-link active' : 'nav-link'" >
              <i class="fas fa-layer-group nav-icon"></i>
              <p>Quản lý Workspace</p>
            </router-link>
          </li>

          <li class="nav-item mt-2">
            <router-link to="/admin/report" :class="($route.path == '/admin/report') ? 'nav-link active' : 'nav-link'" >
              <i class="fas fa-chart-pie nav-icon"></i>
              <p>Quản lý lĩnh vực</p>
            </router-link>
          </li>

          <li class="nav-item mt-2">
            <router-link to="/admin/dataset" :class="($route.path == '/admin/dataset') ? 'nav-link active' : 'nav-link'" >
              <i class="fa-solid fa-database nav-icon"></i>
              <p>Quản lý dataset</p>
            </router-link>
          </li> -->
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'TheSideBar',
  data() {
    return {
      menu: []
    };
  },
  methods: {
    ...mapActions('menu', ['getMenuByRolesAsTree']),
    async getData() {
      let user = JSON.parse(localStorage.getItem('login_info'));
      let roles = user.roleInfo.map(e => e.id);
      let rs = await this.getMenuByRolesAsTree(roles);
      if(rs.isOk) {
        this.menu = rs.data.data;

        // check menu permisson
        const regex = /\//gi;
        let paths = this.menu.map(m => m.path.replaceAll(regex, ''));
        let requestPath = this.$router.currentRoute.value.fullPath.replaceAll(regex, '');
        if(!paths.includes(requestPath)) {
          this.$router.push("/no-permission");
        }
      }
    }
  },
  mounted() {
    this.getData();
  }
}
</script>

<style>
</style>